import React from 'react';

const CancelSubscriptionModal = ({ onClose, onConfirm }) => {
    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4">
            <div className="w-full max-w-md rounded-xl border border-stone-200 bg-white p-6 shadow-2xl">
                <h2 className="mb-3 text-lg font-semibold text-stone-900">Are you sure?</h2>
                <p className="mb-6 text-sm text-stone-600">
                    Your workers will not be able to clock in after the cycle end date.
                </p>
                <div className="flex justify-end space-x-4">
                    <button
                        type="button"
                        className="rounded-md border border-stone-300 bg-white px-4 py-2 text-sm font-medium text-stone-700 transition hover:bg-stone-100"
                        onClick={onClose}
                    >
                        Close
                    </button>
                    <button
                        type="button"
                        className="rounded-md bg-red-600 px-4 py-2 text-sm font-medium text-white transition hover:bg-red-700"
                        onClick={onConfirm}
                    >
                        Confirm Cancellation
                    </button>
                </div>
            </div>
        </div>
    );
};

export default CancelSubscriptionModal;
